<script lang="ts">
  import { AppState } from '../../etc/stores';

  export let color = $AppState.theme.colors.typography;
</script>

<svg
  width="22"
  height="22"
  viewBox="0 0 22 22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M11.0007 1.83398C5.94065 1.83398 1.83398 5.94065 1.83398 11.0007C1.83398 16.0607 5.94065 20.1673 11.0007 20.1673C16.0607 20.1673 20.1673 16.0607 20.1673 11.0007C20.1673 5.94065 16.0607 1.83398 11.0007 1.83398ZM11.0007 15.584C10.4965 15.584 10.084 15.1715 10.084 14.6673V11.0007C10.084 10.4965 10.4965 10.084 11.0007 10.084C11.5048 10.084 11.9173 10.4965 11.9173 11.0007V14.6673C11.9173 15.1715 11.5048 15.584 11.0007 15.584ZM11.9173 8.25065H10.084V6.41732H11.9173V8.25065Z"
    fill={color}
  />
</svg>
